import React from "react";
import parecer from "./img/parecer.jpg";
import parecer1 from "./img/parecer1.JPG";
import parecer2 from "./img/parecer2.JPG";
import parecer3 from "./img/parecer3.jpg";


import './Fauna.css';
import fundofolha from "../image/fundofolha.jpg";
import Header from "../components/Header";

const Laudo = () => {
  const handleGoBack = () => {
    window.history.back(); // Volta à página anterior
  };
  return (
    <div className="fauna-container">
     <Header/>
     
      <div className="fauna-header">
        <h1> Licenciamento Ambiental e Regularização</h1>
        <p>
        A Biolink oferece serviços completos para licenciamento ambiental e regularização, atendendo às necessidades de empresas e empreendimentos de todos os portes. Com uma abordagem estratégica e sustentável, desenvolvemos a suloção que você necessita.
        </p>
      </div>
      <div className="conteudo-grid">
        <div className="conteudo-card">
          <img
            src={parecer1}
            alt="Laudo Técnico"
            style={{
              width: "100%", // Largura total do card
              height: "auto", // Proporção da imagem
              objectFit: "cover", // Ajusta a imagem para preencher o espaço
            }}
          />

          <h3>Obtenção de Licenças Ambientais</h3>
          <p>
            Auxiliamos no processo de obtenção de licenças prévias, 
            de instalação e de operação para diferentes tipos de empreendimentos, como rodovias, ferrovias, indústrias, linhas de transmissão e obras em geral.



          </p>
        </div>
        <div className="conteudo-card">
        <img
            src={parecer2}
            alt="Laudo Técnico"
            style={{
              width: "100%", // Largura total do card
              height: "auto", // Proporção da imagem
              objectFit: "cover", // Ajusta a imagem para preencher o espaço
            }}
          />
           <h3> EIA - RIMA</h3>
          <p>
          Desenvolvemos Estudos de Impacto Ambiental e Relatórios de Impacto Ambiental (EIA/RIMA) detalhados, essenciais para a aprovação de empreendimentos junto aos órgãos ambientais. 
          </p>  
        </div>

        <div className="conteudo-card">
          <img
            src={parecer3}
            alt="Restauro Ecológico"
            style={{
              width: "100%", // Largura total do card
              height: "auto", // Proporção da imagem
              objectFit: "cover", // Ajusta a imagem para preencher o espaço
            }}
          />
          <h3>Relatórios Ambientais Simplificados (RAS)</h3>
          <p>
          Elaboramos Relatórios Ambientais Simplificados (RAS) para atender a 
          empreendimentos de menor impacto ambiental, garantindo agilidade no 
          processo de licenciamento.     
          </p>  
           </div>

        <div className="conteudo-card">
          <img
            src={parecer}
            alt="Restauro Ecológico"
            style={{
              width: "100%", // Largura total do card
              height: "auto", // Proporção da imagem
              objectFit: "cover", // Ajusta a imagem para preencher o espaço
            }}
          />
          <h3>Supervisão de Obras e Empreendimentos</h3>
          <p>
          Realizamos a supervisão de obras e empreendimentos, assegurando o cumprimento das condicionantes ambientais e promovendo a sustentabilidade em todas as etapas do projeto.
          </p>
        </div>

      </div>
      <div className="back-button-container">
      <button onClick={handleGoBack} className="back-button"   > <i class=" fas fa-solid fa-arrow-left"></i>
          Outros serviços
        </button>
      </div>
      <section class="footer" style={{
   background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(138, 138, 138, 0.5)), url(${fundofolha})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    
    
    color: "#fff" // Para contrastar o texto com o fundo
  }}>
        <div class="box-container">
          <div class="box">
            <h3>Navegue</h3>
            <a href="/">
              {" "}
              <i class="fas fa-chevron-right"></i> Início{" "}
            </a>
            <a href="/#about">
              {" "}
              <i class="fas fa-chevron-right"></i> Sobre{" "}
            </a>
            <a href="/#services">
              {" "}
              <i class="fas fa-chevron-right"></i> Serviços{" "}
            </a>
            <a href="/#doctors">
              {" "}
              <i class="fas fa-chevron-right"></i> Equipe{" "}
            </a>
            <a href="/#book">
              {" "}
              <i class="fas fa-chevron-right"></i> Iniciar conversa{" "}
            </a>
            <a href="/#reviews">
              {" "}
              <i class="fas fa-chevron-right"></i> Avaliações{" "}
            </a>
            <a href="/#blogs">
              {" "}
              <i class="fas fa-chevron-right"></i> Blog{" "}
            </a>
          </div>

          <div class="box">
            <h3>Nossos serviços</h3>
            <a href="/florestal">
              {" "}
              <i class="fas fa-chevron-right"></i> Florestal{" "}
            </a>
            <a href="/fauna">
              {" "}
              <i class="fas fa-chevron-right"></i>  Fauna{" "}
            </a>
            <a href="/propriedade-intelectual">
              {" "}
              <i class="fas fa-chevron-right"></i> Propriedade Intelectual{" "}
            </a>
            <a href="/laudos">
              {" "}
              <i class="fas fa-chevron-right"></i> Laudos e Pareceres Técnicos{" "}
            </a>
            <a href="/levantamentos">
              {" "}
              <i class="fas fa-chevron-right"></i> Levantamentos{" "}
            </a>
          </div>

          <div class="box">
            <h3>Contato </h3>
            <a href="https://wa.me/5534999203789?text=Gostaria%20de%20atendimento%20estava%20navegando%20">
              {" "}
              <i class="fas fa-phone"></i> (34) 9 9920-3789{" "}
            </a>
            <a href="https://wa.me/5511986321639?text=Gostaria%20de%20atendimento%20estava%20navegando%20no%20site!%20">
              {" "}
              <i class="fas fa-phone"></i> (11) 9 8632-1639{" "}
            </a>
            <a href="mailto:emerson@biolinksolucoes.com.br">
              {" "}
              <i class="fas fa-envelope"></i> emerson@biolinksolucoes.com.br{" "}
            </a>
            <a href="mailto:omar.neto@biolinksolucoes.com.br">
              {" "}
              <i class="fas fa-envelope"></i> omar.neto@biolinksolucoes.com.br{" "}
            </a>
            <a href="/#book">
              {" "}
              <i class="fas fa-map-marker-alt"></i> Uberlândia, Minas Gerais {" "}
            </a>
          </div>

          <div class="box">
            <h3>Conecte-se conosco!</h3>
            <a href="https://www.facebook.com/">
              {" "}
              <i class="fab fa-facebook-f"></i> facebook{" "}
            </a>
          
            <a href="https://www.instagram.com/biolink_ambiental/">
              {" "}
              <i class="fab fa-instagram"></i> instagram{" "}
            </a>
            <a href="https://www.linkedin.com/company/biolink-ambiental/posts/?feedView=all">
              {" "}
              <i class="fab fa-linkedin"></i> linkedin{" "}
            </a>
           
          </div>
        </div>

        <div class="credit">
          {" "}
          Criado por{" "}
          <span>
            <a href="https://instagram.com"> Biolink </a>
          </span>{" "}
          | ©Todos os direitos reservados.{" "}
        </div>
      </section>
    </div>
  );
};

export default Laudo;
